import error from './errors';
import fields from './fields';

export default {
  error,
  fields,
  app: {
    title: 'Apostille'
  },
  btn: {
    next: 'Suivant',
    prev: 'Précédent',
    cancel: 'Annuler',
    back: 'Retourner en arrière',
    search: 'Procédure de recherche',
    solicitar: `Demande d'apostille`,
    finalizar: 'Terminer',
    verificar: 'Vérifier',
    register: 'Inscription...',
    cambiar: 'Cambiar (fr)',
    solicitando: 'Demander...'
  },
  months: {
    enero: 'Janvier',
    febrero: 'Février',
    marzo: 'Mars',
    abril: 'Avril',
    mayo: 'Mai',
    junio: 'Juin',
    julio: 'Juillet',
    agosto: 'Août',
    septiembre: 'Septembre',
    octubre: 'Octobre',
    noviembre: 'Novembre',
    diciembre: 'Décembre'
  },
  menu: {
    inicio: 'La maison',
    tramite: 'Procédure',
    solicitud: 'Requête',
    seguimiento: 'Le suivi',
    verificar: 'Vérifier',
    contacto: 'Contacto'
  },
  inicio: {
    title: `L'apostille du HAYA en Bolivie`,
    detalle: `L'Apostille de la Convention de La Haye est déjà en vigueur en Bolivie et peut être sollicitée électroniquement par le biais de ce système ou en aidant en personne les entités qui fournissent ce service de légalisation de documents de l'étranger.`,
    btnSolicitar: `Demande d'apostille`,
    btnSeguimiento: 'Statut de ma demande',
    btnVerificar: 'Vérifier mon apostille'
  },
  tramite: {
    title: `Liste des procédures d'apostille`
  },
  solicitud: {
    title: `Formulaire de demande d'Apostille`
  },
  seguimiento: {
    title: `Suivi de votre procédure`
  },
  verificar: {
    title: `Vérifier le document d'apostille`
  },
  BUSCAR_TRAMITE: 'Procédure de recherche',
  PRECIO: 'Le prix',
  VER_DETALLES: 'Voir les détails',
  SOLICITAR_LEGALIZACION: `Demande d'apostille`,
  SOLICITAR_CERTIFICACION: 'Solicitar certificación',
  ESCRIBIR_TRAMITE: 'Escriba aquí el trámite que desea buscar (fr)'
};



// WEBPACK FOOTER //
// ./src/lang/fr/messages.js